const zh = {
  advanced_setting: '高级配置',
  createProject: '新建项目',
  unset: '未设置',
  projectSetName: '项目集名称',
  text_package_config_edit: '编辑',
  text_package_config_edit_role: '编辑角色',
  text_update_package_config: '更新配置会触发构建物清理,确认更新么',
  text_build_package_num_config: '构建物保留数配置',
  text_build_package_config_help: '构建物配置帮助',
  text_app_package_num: '应用保留数量',
  text_online_package_num: '生产环境数量',
  text_build_package_config_switch: '配置生效开关',
  text_build_package_operation: '操作',
  text_build_package_update: '修改',
  text_build_package_input: '请输入',
  text_build_package_enter_num: '请输入正整数',
  text_build_package_detail: '构建物信息',
  text_build_package_app_id: '应用id',
  text_build_package_app_name: '应用名称',
  text_app_package_num_table: '应用构建物数量',
  text_online_package_num_table: '生产环境构建物数量',
  text_choose_status: '请选择配置开关',
  text_status_on: '开',
  text_status_off: '关',
  text_config_error_app_package_limit_must_over_online_limit: '应用保留数要大于生产环境保留数',
  text_build_package_app_size: '应用构建物大小',
  label_select_code_template: '选择模板',
  label_select_language: '选择语言',
  label_pending: '待处理',
  label_my_create: '我创建',
  label_my_collect: '我收藏',
  label_issue: '缺陷',
  label_requirement: '需求',
  label_task: '任务',
  label_risk: '风险',
  label_projectSet: '项目集',
  label_project: '项目',
  label_productline: '产品线',
  text_submit_time: '提交时间',
  label_actualDate: '实际起止时间',
  label_select: '请选择',
  label_yes: '是',
  label_no: '否',
  text_please_input: '请输入',
  text_please_type_integer: '请输入一个整数',
  text_please_type_number: '请输入一个数字',
  text_custom_attribute: '自定义属性',
  text_Owner_department: '负责团队',
  text_open_to_department: '公开到',
  text_owner_product: '归属产品/BU',
  label_search_keyword: '请输入关键字搜索',
  label_description: '描述',
  tip_desc_required: '请输入描述',
  label_expectDate: '计划起止时间',
  text_Health: '健康度',
  text_Good: '好',
  text_Medium: '中',
  text_Bad: '差',
  label_thumbnail: '标识图',
  text_Lifecycle: '生命周期',
  text_Doing: '进行中',
  text_Done: '已完成',
  text_Canceled: '已取消',
  text_Visibility: '公开性',
  text_Public_project: '公开',
  label_visitable_by_all: '所有人可访问',
  text_Private_project: '私密',
  label_visitable_only_by_project_member: '仅成员可访问',
  label_project_name: '项目名称',
  tip_project_title_required: '请输入项目名称',
  click_this_to_create_new_project: '点击新建项目',
  click_this_to_choose_project: '点击选择已有项目',
  git_repo_can_not_be_empty: 'Git库URL不能为空',
  git_repo_format_error: '代码库URL不合法',
  git_repo_url_placeholder: '已有代码库URL（如git@example.aliyun.com:ns/repo.git）',
  tip_program_title_required: '项目集的名称不能为空',
  label_portfolio_name: '项目组合名称',
  text_Please_input_name: '请输入名称',
  label_name: '名称',
  text_Parent_project: '上级项目',
  label_productLine: '产品线',
  text_Parent_production: '上级产品',
  text_portfolio_parent: '父项目组合',
  label_parent_project: '父项目',
  label_portfolio_belongs_to: '所属项目组合',
  label_progress_percentage: '进度',
  label_related_project: '关联项目(集)',
  text_portfolio_components: '项目组合组件',
  label_belonged_project_set: '所属项目集',
  text_Classification: '项目分类',
  text_Namespace: '业务空间',
  text_Develop_project: '研发项目',
  label_project_type: '项目类型',
  text_name: '名称',
  text_Public: '公开',
  text_Accessible_for_everyone: '所有人可访问',
  text_private: '私密',
  text_Accessible_for_project_members: '仅成员可访问',
  text_public_team: '在团队内公开',
  text_Accessible_for_team: '负责团队内的人员可见',
  text_Next: '下一步',
  label_prev_step: '上一步',
  text_Compete: '完成',
  label_base_info: '基本信息',
  text_config_project_group: '配置项目组合组件',
  label_complete: '完成',
  text_Administrator: '管理员',
  text_Accept2: '接受',
  text_Deny2: '拒绝',
  text_Cancel_admin: '取消管理员',
  text_Set_admin: '设置管理员',
  text_Remove: '删除',
  text_Pending: '未处理',
  text_Accepted: '已接受',
  text_Invalid: '失效',
  text_Refused: '已拒绝',
  text_Selected_: '已选中',
  text__items: '条',
  text_Accept_all: '全部接受',
  text_Deny_all: '全部拒绝',
  text_Active_members: '活跃成员',
  text_Member_Name: '姓名',
  text_Nick_Name: '昵称',
  text_email: '邮箱',
  text_Department: '部门',
  text_Mobile: '手机号码',
  text_Staff_ID: '编号',
  text_Invitation_list: '待接受邀请',
  label_status: '状态',
  text_Waiting_for_approval: '待审批',
  text_Refused_list: '已拒绝',
  text_Copy_successfully: '复制成功',
  text_Add: '添加成员',
  text_convert_billing: '切换套餐提示',
  text_click_to_switch: '点击切换',
  text_switch_billing_success: '请关闭该提示框，继续添加成员',
  text_switch_billing_faied: '切换失败：',
  text_Invitation_Link: '通过链接邀请',
  text_invitation_link_tip: '请复制下面的链接发送给用户，邀请其加入企业',
  text_This_invitation_remain_valid_till_: '该邀请链接有效期至',
  text_Copy: '复制',
  text_RAM: '通过RAM添加',
  text_ram_tip1: '您可以添加下方的子账号，或',
  text_ram_tip2: '前往RAM添加子账号',
  text_ram_tip3: '，如果您还不了解RAM，点此',
  text_ram_tip4: '查看帮助',
  text_Display_name: '显示名',
  text_Login_user_name: '登录名',
  label_ok: '确定',
  text_Invitation_Email: '发送邮件邀请',
  text_Email_textarea_tip: '请添加成员的邮箱地址，每行一个，一次最多添加20个。',
  text_Within_10_characters: '10个字符以内',
  text_Apply_to_join_company: '申请加入企业',
  text_Name: '企业名称',
  text_Please_type_your_name_correctly: '请正确输入姓名',
  text_Please_input_your_email: '请输入您的邮箱',
  text_Invalid_emails: '邮箱格式错误，请重新输入',
  text_Join_Company: '申请加入企业',
  text_Your_application_is_waiting_for_approval_please_wait: '你的申请正在审批中，请耐心等待...',
  text_Invalid_invitation_please_contact_the_administrator: '邀请链接已失效，请联系管理员',
  text_Your_application_has_been_approved_you_can: '你的审批已被批准，请点击',
  text__enter_the_company: '前往企业',
  text_Your_application_has_been_denied_please_contact_the_administrator: '你的申请未被批准，如有异议，请联系管理员',
  text_Please_input_company_name: '请输入企业名称',
  text_Invite_Member: '邀请成员',
  text_Please_select_your_company: '请选择您想访问的企业',
  text_Switch: '切换',
  text_No_company: '您还没有加入企业，',
  text_to_create_a_new_one: '新建第一家企业',
  tip_program_title_exist: '项目集已被占用,请重试',
  tip_Plan_end_time_before_start_time: '计划结束时间不可以晚于开始时间',
  label_solution: '解决方案',
  label_new_projectset: '新建项目集',
  text_config_members: '配置成员',
  text_config_joined_projects: '配置参与项目',
  label_next_step: '下一步',
  text_program_manager: '项目集经理',
  tip_enter_program_manager: '请输入项目集经理',
  text_program_member: '项目集成员',
  tip_enter_program_member: '请输入项目集成员',
  label_cancel: '取消',
  label_config_scrum: '配置Scrum 团队',
  tip_scrum_master_require: '请为您的Scrum团队选择Scrum Master',
  tip_product_owner_require: '请为您的Scrum团队选择Product Owner',
  tip_scrum_member_require: '请设置您的Scrum团队成员',
  text_required_please_input: '该字段不能为空,请输入',
  text_import: '导入',
  text_apply: '应用',
  label_product: '产品',
  text_Todo: '待办',
  label_view_all: '查看全部',
  label_empty_data: '暂无数据',
  text_my_favorite: '我的收藏',
  tip_empty_data: '没有相关结果',
  label_view_more: '查看更多',
  text_todo_clear_tip: '恭喜你，已完成所有待办',
  text_portfolio: '项目组合',
  label_Plan_start_and_end_time: '计划起止时间',
  label_Plan_start_time: '计划开始时间',
  label_Plan_end_time: '计划结束时间',
  tip_plan_start_after_end: '计划结束时间不能早于计划开始时间',
  label_creator_and_created_at: '创建人和创建时间',
  label_Actual_start_and_end_time: '实际起止时间',
  label_Actual_start_time: '实际开始时间',
  label_Actual_end_time: '实际结束时间',
  text_person_in_charge: '负责人',
  text_Risk_progress: '风险完成度',
  text_update_time: '更新时间',
  text_latest_complated_milestone: '最新完成里程碑',
  text_edit: '编辑',
  label_collection: '收藏',
  tip_create_at: '创建于',
  label_visible_range: '可见范围',
  label_detail: '查看详情',
  label_Risk_summary: '风险汇总',
  text_Display_Sub_project_Risk: '显示下级项目风险',
  label_risk_level: '风险等级',
  text_status: '状态',
  label_owner_project: '归属项目',
  text_create_time: '创建时间',
  label_private: '私有',
  label_new_project: '新建项目',
  text_tip_title: '提示',
  label_create_project_step: '创建项目',
  label_create_git_step: '创建代码库',
  label_create_app_step: '创建应用',
  label_start_project: '进入项目',
  label_skip_project: '跳过，进入项目',
  label_config_git: '配置代码库',
  label_git: 'Git组/库',
  label_git_repo: 'Git库地址',
  label_git_third: '代码组/库',
  label_git_repo_third: '代码库地址',
  text_select_git_group: '请选择您的Git库所在的组',
  label_application_name: '应用名',
  text_input_application_name: '请输入您的代码所属的应用名称',
  label_Initiate_code_template: '初始化模板',
  label_develop_mode: '开发模式',
  text_select_develop_mode: '请选择开发模式',
  label_develop_mode_free: '自由模式',
  label_read_more: '了解更多',
  label_develop_mode_branch: '分支模式',
  label_develop_mode_gitFlow: 'Git Flow',
  label_docker_build_or_not: 'Docker构建',
  label_docker_repo_url: '镜像地址',
  label_app_release_language: '开发语言',
  label_application_type: '程序类型',
  label_deploy_option: '部署方式',
  label_build_config_step: '配置代码内容',
  label_deploy_config_step: '配置应用',
  label_code: '编码',
  label_test: '测试',
  label_publish: '发布',
  label_service_common: '通用',
  label_service_general: '通用',
  label_service_product: '产品',
  label_service_develop: '开发',
  label_service_testing: '测试',
  label_service_publish: '发布',
  label_service_other: '其他',
  label_service_doc: '文档',
  label_service_tile_workitem: '工作项',
  label_service_tile_report: '报表',
  label_service_tile_chart: '图表',
  label_service_tile_kanban: '看板',
  label_service_tile_risk: '风险',
  label_service_tile_report2: '周报',
  label_service_tile_document: '文档',
  label_service_tile_resource: '资源',
  label_service_tile_milestone: '计划',
  label_service_tile_meeting: '会议纪要',
  label_service_tile_lark: '语雀',
  label_service_tile_req: '需求',
  label_service_tile_demo: 'Demo',
  label_service_tile_projectChange: '项目变更',
  label_service_tile_version: '版本',
  label_service_tile_version_app_config: '应用配置',
  label_service_tile_task: '任务',
  label_service_tile_sprint: '迭代',
  label_service_tile_code: '代码',
  label_service_tile_pipeline: '流水线',
  label_service_tile_project_pipeline: '代项目流水线',
  label_service_tile_issue: '缺陷',
  label_service_tile_lab: '实验室',
  label_service_tile_TC: '测试用例',
  label_service_tile_regression: '回归',
  label_service_tile_test: '测试',
  label_service_tile_crDev: '变更',
  label_service_tile_app: '应用',
  label_service_tile_alipay_doccenter: 'Javis文档',
  label_service_tile_product_version_app_config: '应用配置',
  label_service_tile_product_version: '版本',
  label_service_tile_lib: '二方库',
  label_service_tile_product_version_inst: '制品',
  label_service_tile_file: '文件',
  label_service_tile_planItem: '规划',
  label_service_desc_workitem: '工作项，包含任务，需求，缺陷，帮助项目管理和落地实现',
  label_service_desc_report: '多维度项目数据分析',
  label_service_desc_chart: '多维度项目数据分析',
  label_service_desc_kanban: '以看板视图管理工作进展，聚焦事项的快速推进，配合敏捷开发实践，提高协作效率',
  label_service_desc_risk: '管理项目的风险，及时通知，层层上报',
  label_service_desc_report2: '便捷生成项目周报，汇报项目进展',
  label_service_desc_document: '记录文档，沉淀知识',
  label_service_desc_resource: '项目的人力资源管理',
  label_service_desc_milestone: '整体规划项目中各个里程碑以及具体的工作项',
  label_service_desc_meeting: '会议纪要统一管理',
  label_service_desc_lark: '接入语雀团队知识库',
  label_service_desc_req: '记录、查看需求，可自定义工作流，可添加自定义字段，方便跟踪管理',
  label_service_desc_demo: '接入Demo+项目',
  label_service_desc_projectChange: '统一管理项目的需求、里程碑计划和人员等变更',
  label_service_desc_version: '版本',
  label_service_desc_version_app_config: '配置应用的版本规则：固定版本或最新版本',
  label_service_desc_task: '记录日常待办事项，跟进进展',
  label_service_desc_sprint: '按迭代周期规划和管理要交付的需求，迭代锁定后不宜变更需求，确保聚焦，确保完成交付',
  label_service_desc_code: '代码',
  label_service_desc_pipeline: '可以自行配置的发布流水线',
  label_service_desc_project_pipeline: '代项目流水线',
  label_service_desc_issue: '管理缺陷，可关联到代码变更，方便开发及测试同学跟踪',
  label_service_desc_lab: '实验室',
  label_service_desc_TC: '测试用例提供了手工用例管理功能，用于测试同学将测试步骤和测试结果进行记录和查看',
  label_service_desc_regression: '回归功能提供将基于应用稳定的测试功能脚本（实验室）进行每日定时的回归，用于验证测试产品的质量',
  label_service_desc_test: '测试服务用于提供给用户场景化的测试服务能力',
  label_service_desc_crDev: '承载应用内容的变更过程，包括代码，包、容器等变更，集成了持续集成和各种审核工具，是发布的前站服务',
  label_service_desc_app: '应用生命周期、元数据管理，跟应用相关的基本信息、变更发布都可以在这里找到',
  label_service_desc_alipay_doccenter: 'Javis文档',
  label_service_desc_product_version_app_config: '配置应用的版本规则：固定版本或最新版本',
  label_service_desc_product_version: '定义产品版本，按版本管理需求缺陷',
  label_service_desc_lib: '项目二方库服务',
  label_service_desc_product_version_inst: '产品版本制品。每运行一次产品版本流水线，都会有一次唯一的制品产生',
  label_service_desc_file: 'aone2文件服务',
  label_service_desc_planItem: '制定产品的规划，组织和管理需求',

  label_plugin_desc_model: '以树形结构定义产品模块或业务模块，按模块分类管理需求',
  label_plugin_desc_tag: '可以给需求、缺陷、子项目等打标签，分类管理',
  label_plugin_desc_version: '定义产品版本，按版本管理需求缺陷',
  label_plugin_desc_across_enterprise: '与另一个企业共享该项目内的数据',
  label_plugin_set_across_enterprise_tip: '开启共享，合作企业之间共享项目数据',
  label_plugin_cancel_across_enterprise_tip: '取消共享，将不再与其他合作企业共享数据',

  text_feedback: '反馈',
  label_quick_start: '快速开始',
  label_help_doc: '文档与帮助',
  label_edit: '编辑',
  label_update_milestone: '编辑里程碑',
  label_new_milestone: '新建里程碑',
  label_Actual_completed_time: '实际完成时间',
  tip_actual_completed_time: '请输入实际完成时间',
  tip_status_selected: '请选择状态',
  label_module: '模块',
  label_Plan_completed_time: '计划完成时间',
  text_expected_end_date_hint: '请输入计划完成时间',
  tip_unfinished: '未完成',
  tip_finished: '已完成',
  text_Archived: '已归档',
  text_display_archived_milestone: '显示归档里程碑',
  text_operation: '操作',
  text_tag: '标签',
  label_project_ascription: '项目归属',
  label_project_plan: '项目计划',
  text_program_tip1: '“项目集”集合了多个项目的数据，方便查看和统计',
  text_program_tip2: '但不能管理项目数据。',
  tip_archive_make_sure: '确定结项吗？',
  tip_archived_cancel_success: '取消归档成功',
  tip_archived_success: '结项成功',
  label_archive_cancel: '取消归档',
  label_archive: '结项',
  label_project_archive: '项目结项',
  tip_project_archive: '项目完成后，可将项目标记为结项。已结项的项目默认不显示在项目列表、项目搜索结果中；已结项项目的工作项数据在图表统计时仍然会统计在内；结项后所有迭代自动关闭，不可新增迭代；结项后不可新增工作项；结项后不可修改模板；结项后不可重新开启，请谨慎操作。',
  tip_collection_cancel_success: '取消收藏成功',
  tip_collection_success: '收藏成功',
  label_collection_cancel: '取消收藏',
  text_Update_success: '更新成功',
  text_Update: '更新',
  tip_save_success: '保存成功',
  label_confirm: '确认',
  text_Add_member_role: '+ 添加角色',
  text_select_role: '请选择角色',
  tip_waiting_export: '正在导出，导出结果将以旺旺和邮件方式告知；',
  tip_waiting_export_vpc: '正在导出，导出结果将以邮件方式告知；',
  text_Export_members: '导出成员',
  label_not_allow_to_delete_member: '该角色下有成员, 不能删除!',
  tip_delete_make_sure: '确定删除吗？',
  label_delete: '删除',
  label_add_to_dingding_calendar: '加入钉钉日历',
  label_covered_existing_member: '导入后会保留现有成员并追加新成员, 确定导入其他项目的成员吗？',
  text_run_success: '操作成功',
  text_Import_members: '导入成员',
  tip_project_selected: '请选择项目',
  text_Success_to_remove_member: '删除成员成功',
  label_select_role: '请选择角色',
  label_save: '保存',
  text_Support_markdown: '支持Markdown',
  label_preview: '预览',
  label_remove: '移除',
  tip_enabled: '启用',
  label_drag_sort: '可拖拽改变顺序',
  tip_opened: '已启用',
  label_all: '全部',
  text_remove_service_tip: '移除服务不会丢失数据，重新启用数据仍然存在。',
  label_add: '添加',
  text_create_a_new_version: '新建版本',
  text_Display_archived_version: '显示归档版本',
  text_Unpublished: '未发布',
  text_Published: '已发布',
  label_locale: 'zh_CN',
  text_Related_work_item: '关联工作项',
  label_Actual_publish_time: '实际发布时间',
  label_Plan_publish_time: '计划发布时间',
  text_Parent_version: '父版本',
  label_New_module: '新建模块',
  label_New_tag: '新建标签',
  label_share_tag: '分享标签',
  label_edit_tag: '编辑标签',
  text_tag_share_info: '标签分享给',
  text_tag_share_sub_or_related: '所有子孙项目／所有关联项目',
  text_tag_other_project: '其他项目：',
  text_delete_module_success: '模块删除成功',
  tip_inherit_all: '确定继承父项目的全部模块?',
  text_inferit_parent_project_config: '继承父项目的配置',
  text_Inherit_all: '继承全部',
  label_Inherit_module: '继承模块',
  tip_module_belong_to: '本模块归属于',
  tip_click_to_manager_module: '点击前往管理',
  label_created_at: '创建时间',
  text_module_inherit_from: '此模块继承自项目 ',
  text_module_remove_tip: ' ，此操作仅从当前项目移除该模块，不会删除模块，如需删除请前往 ',
  text_parent_module: '父模块',
  remove_success: '移除成功',
  enable_success: '启用成功',
  label_cooperation_project: '对外合作项目',
  text_initiate_cooperation: '发起合作',
  text_participate_cooperation: '参与合作',
  label_project_title: '项目名称',
  label_project_des: '项目描述',
  label_share_content: '共享内容',
  text_choose_shared_info: '选择共享哪些信息给合作方:',
  text_project_base_info: '项目的基本信息',
  text_project_member_info: '项目的成员信息',
  text_project_work_item: '工作项相关的数据和配置',
  label_own_info: '本方信息',
  text_project_owners: '项目负责人',
  text_project_members: '项目成员',
  label_participant_info: '合作方信息',
  text_partner_company: '合作方企业',
  label_invitation_code: '邀请码',
  text_code_system_help: '系统账户帮助',
  code_system_user: '系统账户',
  enter_code_system_user: '输入用户名进行搜索',
  more_options: '更多选择',
  title_edit_view: '编辑视图',
  lable_crp_migrate: 'CRP迁移',
  refresh_login: '登录状态过期，请刷新页面。',
  test_create_issue_init_assignedTo: '创建缺陷时，“指派给”自动置为模块负责人',
  test_go_into_all_defeat_types: '将生效到所有缺陷类型',
  test_workflow_role_required_cf: '流转权限 & 流转必填属性',
  text_delete_confirm: '确认删除吗？',
  label_set_status_config_title: '设置流转权限&流转必填属性',
  text_return: '返回',
  text_disabled: '禁用',
  test_confirm_to_create_code_account: '确认保存系统账户',
  test_confirm_to_delete_code_account: '确认删除系统账户',
  test_create_code_account_success: '保存系统账户成功',
  test_delete_code_account_success: '删除系统账户成功',
  test_create_code_account_fail: '保存系统账户失败,系统账户已存在',
  test_delete_code_account_fail: '删除系统账户失败',
  test_no_code_account: '当前不存在系统账户',
  test_enter_right_code_account: '请输入正确系统账户',
  label_warning: '警告',
  text_delete_project: '删除项目',
  text_delete_project_info: '删除项目，将同时删除归属于该项目的工作项、里程碑、风险、版本、模块、迭代、应用、流水线等数据，且无法恢复！',
  text_delete_project_set_info: '删除项目集，将解除该项目集合与关联项目（集）的关联关系，同时删除归属于该项目集的工作项、里程碑、风险、版本、模块、迭代等数据，且无法恢复！',
  text_delete_project_portfolio_info: '删除项目组合，将解除该项目组合与项目组合组件的关联关系。',
  label_delete_project_number_str_vpc: '该项目中有$1个归属的工作项，$2个里程碑，$3个版本，$4个模块，$5个迭代，$6个应用，$7个流水线, $8个文档。(测试用例数量暂未统计)',
  label_delete_project_number_str: '该项目中有$1个归属的工作项，$2个里程碑，$3个版本，$4个模块，$5个迭代，$6个应用，$7个流水线, $8个文档，$9个测试用例',
  text_click_to_confirm_delete_project: '(点击确认将直接删除)',
  text_click_to_confirm_delete_project_with_many_workitem: '(由于归属该项目的工作项数据较多，确认删除后，将默认保留2天，期间可取消删除，否则2天后自动删除)',
  text_input_project_name_to_confirm: '确定删除，请输入项目名称验证',
  text_error_when_check_project_name: '项目名称检验失败',
  text_submit_delete_project_tooltip: '$1于 $2 将此项目登记删除，系统将于 $3 执行删除操作。',
  label_empty_for_i18n: '',
  text_project_has_sub_project: '该项目下有$1个子项目，移走后才能删除。',
  text_project_is_collab: '该项目为跨企业合作项目，请先解除跨企业协作关系',
  text_across_enterprise: '跨企业协作',
  text_project_submit_to_delete_success: '项目登记删除成功',
  text_target_status: '目标状态',
  text_role_to_set_target_status: '只有以下角色能将状态置为目标状态',
  text_target_status_set_cfs: '流转到目标状态时，以下属性必填',
  text_please_select_target_status: '请选择目标状态',
  text_run_failed: '操作失败',
  text_select_required_cf: '请选择必填属性',
  text_has_right_rols: '有权限的角色',
  text_required_cf_before_status_flow: '状态流转前必填属性',
  text_role_set_to_status: '<span class="status-config-attr">只有 <strong>$1</strong> 能将状态置为 <strong>$2</strong></span>',
  text_role_set_to_status_null: '<span class="status-config-attr">（无权限限制）</span>',
  text_cf_required_set_to_status: '<span class="status-config-attr">字段 <strong>$1</strong> 必填</span>',
  text_cf_required_set_to_status_null: '<span class="status-config-attr">(无必填字段)</span>',


  text_custom_rule: '自定义规则',
  text_add_rule: '添加规则',
  text_input_rule_name: '请输入规则名称',
  text_rule_name: '规则名称',
  text_trigger_event: '触发事件',
  text_actuator: '执行操作',
  text_return_rule_list: '返回规则列表',
  text_add_rule_trigger: '添加触发事件',
  text_add_actuator_group: '添加操作组',
  text_add_actuator: '添加操作',
  text_status_auto_flow: '状态自动流转',
  text_window_to_fill_cfs: '弹框填写属性',
  text_attr_auto_flow: '自动更新属性',
  text_select_status: '选择状态',
  text_step_status_auto_flow: '状态自动流转',
  text_step_window_to_fill_attrs: '弹框填写属性',
  text_when_status_is: '当状态为',
  text_status_flow_to: '，则流转到',
  text_add_status_auto_flow: '添加状态流转',
  text_start_review: '需求发起评审',
  text_review_started_to_trigger_event: '需求发起评审时，会触发此事件',
  text_finish_review: '需求评审通过',
  text_finish_review_to_trigger_event: '工作项当前评审的邀评人全部通过该评审时，会触发此事件',
  text_run_condition: '执行条件',
  text_always_run: '始终执行',
  text_rule_name_not_null: '规则名称不能为空',
  text_rule_actuators_not_null: '规则执行操作不能为空',
  text_project_cancel_to_delete_success: '取消项目删除登记成功',
  text_project_delete_success: '项目删除成功',

  text_rdc_ram_authorization_add: '确认进行绑定么',
  text_rdc_ram_authorization_update: '确认重新进行云效授权么',
  text_rdc_ram_authorization_delete: '确认解除当前绑定么',
  text_rdc_ram_authorization_ram: '确认进行RAM授权么',
  button_rdc_ram_authorization_rdc: '绑定',
  button_rdc_ram_authorization_ram: '授权',
  button_rdc_ram_authorization_rdc_update: '重新云效授权',
  button_rdc_ram_authorization_rdc_delete: '解绑',
  text_rdc_ram_authorization_rdc_no_user_id: '未授权',
  text_rdc_ram_authorization_rdc_no_user_name: '未授权',
  label_rdc_ram_authorization_rdc_user_id: '授权用户ID',
  label_rdc_ram_authorization_rdc_user_name: '授权用户昵称',
  text_rdc_ram_authorization_msg_fail_delete: '解除授权失败',
  text_rdc_ram_authorization_msg_fail_add: '添加授权失败',
  text_rdc_ram_authorization_msg_fail_update: '重新授权失败',
  text_assigned_to: '指派给',
  label_empty_key: '空',
  text_default_value: '默认值',
  text_attr_name: '属性名',
  text_add_attr: '添加属性',
  text_rule_list_with_description: '<strong>自定义流程规则</strong>（被触发的规则将会按列表的顺序执行）',
  text_trigger_event_can_not_be_null: '触发事件不能为空',
  text_delete_actuators: '删除操作组',
  text_delete_rule_confirm: '确认删除该规则吗？',
  label_code_repo_type: '代码库名称',
  text_select_code_repo_type: '请选择您的代码库名称',
  text_Search_Region_Member: '输入关键字，回车搜索',
  text_disk_type_cloud: '普通云盘',
  text_disk_type_cloud_efficiency: '高效云盘',
  text_disk_type_cloud_ssd: 'SSD云盘',
  text_disk_type_ephemeral_ssd: '本地云盘',
  text_resource_specification: '资源规格',
  text_security_groupName: '所属安全组',
  text_security_disk_type: '磁盘类型',
  text_security_disk_size: '磁盘大小',
  text_machine_name: '机器名称',
  text_machine_password: '请输入机器密码',
  text_lab_password: '机器密码',

  text_machine_buy: '购买机器',
  text_tempalte_id: '模板id',
  text_tempalte_region: '所属区域',
  text_tempalte_name: '模板名称',
  text_tempalte_language: '语言',
  text_tempalte_ip: 'ip',
  text_tempalte_status: '状态',
  text_tempalte_machine_password: '机器密码',
  text_tempalte_buy_num: '购买数量',
  text_buy_machine_status: '机器状态',
  text_buy_machine_buy_sucess: '购买成功',
  text_buy_machine_buy_starting: '机器启动中',
  text_buy_machine_buy_running: '机器启动完成',
  text_buy_machine_id: '机器ID',
  text_go_aliyun_ecs: '前往阿里云ECS控制台',
  text_resource_specification_introduce: '请键入合法资源规格，点此处查看详细规格说明',
  label_disable: '禁用',
  text_enable_confirm: '确认启用吗',
  text_disable_confirm: '确认禁用吗',
  text_parent_workitem_done_or_cancel: '父工作项完成/取消',
  text_child_workitem_done_or_cancel: '所有子工作项全部完成/取消',
  text_parent_workitem_done_or_cancel_description: '此规则为系统提供，如果启用，那么以下描述将生效：<br/>当父工作项已完成时（<strong>被置为正常结束状态视为已完成</strong>），' +
  '所有未关闭的子工作项将自动置为已完成；当父工作项被取消时（<strong>被置为异常结束状态视为已取消</strong>），所有未关闭的子工作项将自动取消。',
  text_child_workitem_done_or_cancel_description: '此规则为系统提供，如果启用，那么以下描述将生效：<br/>当所有子工作项都被取消时（<strong>被置为异常结束状态视为已取消</strong>），' +
  '父工作项自动被取消；当所有子工作项都已关闭，且至少有一个工作项是已完成（<strong>被置为正常结束状态视为已完成</strong>）状态，则父工作项自动被置为已完成。',
  text_disabled_rule: '未启用规则',
  text_rule_instruction: '规则说明',
  text_save_failed: '保存失败',
  label_new_buildImage: '新增镜像',
  label_edit_buildImage: '编辑镜像',
  text_modify: '修改',
  text_modify_time: '修改时间',
  text_creator: '创建者',
  text_modifier: '修改者',
  text_image_name: '镜像名称',
  text_other_required_info: '其他必要信息',
  label_start_time: '开始时间',
  label_end_time: '结束时间',
  text_update_project_date_to_weekend: '确定将开始时间或结束时间设置在周末?',
  label_update_project_date_hint: '修改项目(集)的起止时间',
  text_milestone_date_weekend_hint: '注意：该里程碑设置在周末',
  text_add_workitem_relation_change: '工作项新关联变更',
  text_add_workitem_relation_change_description: '工作项新关联了一个变更，会触发次事件',
  text_relation_change_publish: '工作项关联的变更发布上线',
  text_relation_change_publish_description: '工作项关联的所有变更全部发布上线时，会触发此事件',
  text_tab_machine_manage: '机器管理',
  text_tab_ecs_image_template: 'ECS镜像模板',
  text_tab_buy_ecs_history: '机器购买历史',
  text_tab_private_proxy_machine: '代理机',
  text_re_ecs_password: '确认密码',
  text_not_same_ecs_password: '两次输入密码不一致',
  text_same_ecs_password: '两次输入密码保持一致',
  text_button_buy_ecs: '购买机器',
  text_button_buy_ecs_and_deploy: '购买机器并部署',
  text_select_ecs_template: '选择模板为',
  text_buy_ecs_number_is: ',购买机器数量为',
  text_sure_to_buy_ecs: '台,确认购买么',
  text_ecs_password_rule: '8 - 30 个字符，必须同时包含三项（大写字母、小写字母、数字、 ()`~!@#$%^&*-+=|{}[]:;\'<>,.?/ 中的特殊符号）。',
  text_buy_ecs_ing: '机器购买中...',
  text_buy_ecs_help: '在该页面购买机器，将会自动将机器关联到当前企业。购买新机器，只收取ECS费用，需要保证账户余额充足',
  text_import_ecs_help: '在该页面导入机器，只支持VPC网络ECS导入',
  text_button_close: '关闭',
  text_button_show_ecs_history_detail: '查看机器状态',
  text_buy_ecs_time: '购买时间',
  text_ecs_rehion: '所属区域',
  text_buy_ecs_operator: '操作人',
  text_buy_ecs_account: '购买账户',
  text_buy_ecs_num: '购买数量',
  text_buy_ecs_type: '操作类型',
  text_operate: '机器状态',
  text_now_ram_other: '当前是别人',
  text_ram_nickname: '昵称',
  text_ram_help: '适当绑定授权后，云效中本企业的成员，可以通过云效用指定阿里云账户的身份，完成购买ECS机器等操作。详见',
  text_ram_help_doc: '帮助文档',
  text_ram_now_status: '当前状态',
  text_ram_now_bind_and_authorization: '已授权并绑定',
  text_ram_region_user: '云效中本企业可以用阿里云主账户',
  text_ram_region_username: '的身份完成操作',
  text_ram_no_bind: '尚未绑定',
  text_ram_bind_and_authorzation: '我授权并绑定',
  text_ram_authorization_step_1: ' 第一步，授权云效有权用我的身份完成操作。',
  text_ram_step_finish: ' 已完成',
  text_ram_bind_step_2: ' 第二步，配置云效中本企业用我的身份完成操作。',
  text_ram_bind_step_2_pre: '第二步，配置云效中本企业用我',
  text_ram_bind_step_2_suffix: '的身份完成操作',
  text_ram_unbind: '解除当前绑定',
  text_ram_unbind_text_pre: '云效中本企业不再用当前绑定的阿里云主账户',
  text_ram_unbind_text_suffix: '的身份完成操作',
  text_ram_now_bind_account: '当前已绑定账户',
  text_ram_confirm_bind: '确认要进行替换么',
  text_ram_please_bind_first: '请先进行授权绑定',
  text_template_help: '为保证您正确创建模板，请参考文档以了解ECS实例相关参数,详见',
  text_build_image_requirement: '为保证正确使用构建镜像，录入的镜像需要是公共镜像，并且大小不超过1G，镜像地址需带digest信息(执行命令 docker images --digests)',
  text_build_image_help: '自定义构建镜像的具体使用详见',
  text_ecs_instance_detail_help: '1. 为保证您可以正确创建ECS模板，您可能需要了解ECS实例相关参数，请参考',
  text_create_template_help: '2. 如您需更进一步的详细引导，请参考',
  text_custom_image_help: '若需要自定义镜像，请参考',
  text_only_vpc_instance_help: '云效中只能创建基于VPC的ECS实例，若要创建VPC，请参考',
  text_create_vswitch_help: '创建VSwitch，请参考',
  text_create_security_group_help: '创建安全组，请参考',
  text_input_correct_resource_specification_help: '请您键入合法资源规格，若需了解资源规格详情，请参考',
  text_add_template_help_doc: '帮助文档',
  text_guide_for_inherit_from_parent: '父级项目未配置任何规则，打开项目自主配置开关，可自行添加。',
  text_use_self_project_config: '开启本项目自主配置（关闭时，配置继承自父级项目）',
  text_rule_custom_buttons: '<strong>自定义按钮</strong>（按钮将显示在工作项详情，可配置按钮对应的操作，点击按钮将执行对应的操作）',
  text_rule_button_name: '按钮名称',
  text_actuator_content: '操作内容',
  text_button_anthorized_role: '执行权限',
  text_button_select_anthorized_role: '请选择角色，如不设定则为所有角色都有权限',
  text_button_visible_scope: '显示范围',
  text_button_select_visible_scope: '请选择可见的状态',
  text_button_name_not_null: '按钮名称不能为空',
  tip_inherit_parent_permission_denied: '没有操作权限，当前操作只有项目管理员可操作，如需操作，请联系项目管理员',
  tip_not_allowed_on_current_page: '本页面不支持当前操作',
  text_all_statuses: '（所有状态）',
  text_all_roles: '（所有角色）',
  text_docker_repo_operate_failed: '镜像操作失败，请重试',
  label_delete_milestone: '删除里程碑',
  text_delete_success: '删除成功',
  label_milestone_overall_title: '的整体计划',
  label_export: '导出',
  label_set_to_completed: '置为完成',
  text_client_button: '删除后，该标签会在当前项目的所有工作项上消失，确定删除？',
  text_delete_share_tag_message: '该标签是共享标签，删除后这个标签将不在这个项目内展示',
  label_go_to_today: '今天',
  hint_loading: '加载中，请稍后',
  text_add_url_link: '添加跳转链接',
  tip_input_url: '请输入url链接',
  text_url_link: '跳转链接',
  text_url_link_example: '链接将携带项目Id和工作项Id信息，如：http://example.com?akProjectId=xxx&issueId=xxx',
  label_project_obj_name: '项目(集)名称',
  label_admin_pm: '负责人(PM)',
  label_project_creator: '项目创建人',
  label_milestone_cnt: '里程碑数量',
  label_duration: '时长',
  text_day_singular: '天',
  text_day_plural: '天',
  hint_delay: '超期',
  hint_double_click_edit: '双击可修改此内容',
  hint_milestone_name_length: '里程碑名称不能超过50个字',
  hint_milestone_des_length: '里程碑描述不能超过1000个字',
  hint_milestone_name_null: '里程碑名称不能为空',
  text_milestone_date_weekend: '确定将该里程碑设置在周末?',
  text_set_workitem_readonly: '设置工作项为只读',
  tip_workitem_readonly: '该类型下的工作项将被置为只读状态，任何人无法编辑。',
  tip_division_deleted: '由于组织架构调整，当前部门已被删除，请及时核对并更新部门信息！',
  tip_milestone_before_project: '里程碑的计划完成时间($1)早于项目开始时间($2)，项目的开始时间将更新为里程碑的计划完成时间，确认更新吗？',
  tip_milestone_after_project: '里程碑的计划完成时间($1)晚于项目结束时间($2)，项目的结束时间将更新为里程碑的计划完成时间，确认更新吗？',
  label_set_cancel: '置为取消',
  tip_milestone_cnt_hint: '该项目(集)有',
  tip_goto_milestone: '个里程碑，可点击前往查看',
  tip_milestone_null: '该项目(集)没有里程碑',
  label_milestone_set_start_date: '里程碑计划完成时间未设置，请设置时间',
  label_milestone_illustration: '图例说明',
  label_milestone_illustration_doing: '未完成，未超期的里程碑',
  label_milestone_illustration_done: '已完成的里程碑',
  label_milestone_illustration_done_delay: '超期完成的里程碑',
  label_milestone_illustration_doing_delay: '超期未完成的里程碑',
  label_milestone_illustration_cancel: '已取消的里程碑',
  label_milestone_illustration_multi: '时间点相同的多个里程碑',
  label_project_member: '项目成员',
  label_investment_duration: '投入时长',
  label_plan: '计划',
  label_in_actuality: '实际',
  label_view: '查看',
  label_milestone_endDate_null_hint_pre: '总共$total个，有',
  label_milestone_endDate_null_hint_end: '个未设置计划完成时间',
  label_unit: '个',
  label_milestone_set_endDate: '设置里程碑时间',
  label_milestone_name: '里程碑名称',
  label_next_milestone: '下一个里程碑',
  label_recent_complete_milestone: '最近完成里程碑',
  label_set_endDate: '设置时间',
  label_none: '无',
  label_milestone_set_endDate_tip_pre: '以下是',
  label_milestone_set_endDate_tip_end: '中未设置时间点的里程碑',
  label_filter_and_display: '过滤',
  label_display: '显示',
  label_filter_by_project_tag: '按项目标签过滤',
  text_display_project_divider: '显示项目分隔线',
  text_display_delayed_unfinished_milestone: '只显示超期未完成的里程碑',
  hint_hide_group_member: '隐藏该成员',
  hint_delete_group: '删除该分组',
  hint_hide_group: '隐藏该分组',
  text_confirm_hide_member: '确定从分组中隐藏该成员吗？在角色分组中隐藏成员，不会改变项目上的成员的角色。',
  label_group_by_role: '按成员角色分组',
  label_group_by_custom: '按自定义分组',
  hint_delete_group_member: '删除该成员',
  text_confirm_delete_member: '确定从分组中删除该成员吗？',
  text_title_hide_member: '隐藏成员',
  text_title_delete_member: '删除成员',
  text_title_hide_group: '隐藏分组',
  text_title_delete_group: '删除分组',
  text_confirm_hide_group: '确定隐藏分组：($1) 吗？',
  text_confirm_delete_group: '确定删除分组：($1) 吗？删除后，该分组中所有成员的投入信息将被清除。',
  hint_add_group_member: '添加人员',
  hint_add_group: '添加分组',
  text_group_name: '分组名',
  hint_edit_group: '编辑该分组',
  text_title_edit_group: '编辑分组',
  label_form_group: '分组',
  label_form_member: '人员',
  text_add_member_ps: '说明：',
  text_add_member_ps_prefix: '如果要添加的人员不在当前项目中，请先前往',
  text_add_member_ps_here: '这里',
  text_add_member_ps_postfix: '将其添加为项目成员并为其设置角色。',
  tip_input_group_name: '请输入名字',
  tip_input_select_group: '请选择分组',
  tip_input_select_member: '请选择人员',
  label_project_announcement: '项目公告',
  hit_no_optional_group: '无可选分组',
  hit_no_optional_member: '无可选人员',
  label_edit_invest_date: '进入编辑',
  hint_edit_invest_date: '点击进入编辑态后，可以通过点击日期单元格快捷编辑成员投入时间',
  hint_exit_edit_invest_date: '退出编辑态后，点击单元格不可编辑成员投入时间',
  label_exit_edit_invest_date: '退出编辑',
  label_back_to_old_version: '返回旧版',
  label_display_full_screen: '全屏显示',
  hint_exit_full_screen: '当前为全屏模式，Esc退出',
  text_total_members: '等($1)人',
  text_hide_project_divider: '隐藏项目分隔线',
  label_history_version: '历史版本',
  label_current_version: '当前版本',
  label_return: '返回',
  label_revert_to_version: '还原为此版本',
  tip_revert_version: '还原为此版本会覆盖当前的公告，确定还原吗？',
  label_use_build_image_or_not: '自定义构建镜像',
  label_relate_existing_projects: '关联已有项目',
  tip_input_related_project_name: '输入关联项目的名称进行搜索',
  label_more: '更多',
  label_lock: '锁定',
  label_unlock: '解锁',
  label_exit_project: '退出项目',
  label_approval_project: '立项审批',
  text_lock_req_hint: '锁定后不能往项目添加需求，不能修改本项目需求，不能把需求移出本项目，不能取消、归档和删除需求',
  text_project_locked_hint: '项目需求已锁定，添加、修改、删除和取消需求须走审批流程',
  tip_cancel_archive_make_sure: '确定取消归档吗？',
  tip_project_cancel_archive: '项目取消归档时，迭代、工作项等不会自动取消归档',
  tip_project_unlock_confirm: '确认取消锁定项目吗？',
  label_approver: '审批人员',
  label_cc: '抄送',
  label_project_approval: '立项审批',
  label_project_approval_undo: '尚未立项审批',
  label_project_approval_doing: '立项审批中',
  label_project_approval_pass: '立项审批通过',
  label_project_approval_fail: '立项审批未通过',
  label_tips_start_project_approval: '在"更多"中可以开始立项审批',
  label_tips_restart_project_approval: '在"更多"中可以重新开始立项审批',
  label_project_info: '项目基本信息',
  label_milestone: '里程碑',
  tip_input_approver: '请输入审批人员',
  label_announcement: '公告',
  label_summary_members: '成员',
  label_manager: '管理',
  label_version: '版本',
  label_new: '新建',
  label_total_risk_num: '共有($1)个风险，',
  label_service: '服务',
  label_sprint: '迭代',
  label_milestone_plan: '里程碑计划',
  tip_multi_milestone: '等$1个里程碑',
  label_insert_term: '插入词条',
  label_term: '词条',
  label_create_term: '创建词条',
  tip_no_term_list: '尚未创建词条',
  label_aone_data_module: 'Aone数据模块',
  label_relation: '关联',
  text_preview: '样式预览',
  text_system_error: '系统错误',
  label_High: '高',
  label_Low: '低',
  label_total_projects: '共$total个项目',
  label_child_project: '子项目',
  label_developer: '开发',
  label_branch: '分支',
  label_Change_content: '变更原因',
  label_env: '项目环境',
  label_Change: '变更',
  text_cr_releasing: '发布中',
  text_cr_pending: '待发布',
  text_cr_pending_integration: '待集成',
  text_cr_in_integration: '集成中',
  text_application: '申请',
  text_cr_developing: '开发中',
  text_cr_test: '测试中',
  text_cr_finish: '已完成',
  text_cr_closed: '已关闭',
  text_cr_second_base: '环境更新中',
  text_cr_in_audit: '审批中',
  text_cr_compiling: '编译审计中',
  label_New_change: '新建变更',
  text_New_RPM_change: '新建RPM变更',
  text_Publish_2nd_party_lib: '新建二方库发布',
  text_Load_3rd_party_lib: '新建三方库引入',
  text_Change_module: '新建模块变更',
  label_total_crs: '共 $total 个变更',
  text_tab_swarm: 'swarm集群证书导入',
  text_tab_k8s: 'kubernetes集群证书导入',
  text_tab_account: 'docker镜像账号管理',
  label_shown_project_block: '显示的区块',
  label_hidden_project_block: '未显示的区块',
  label_click_to_edit_layout: '点击配置概况页布局',
  label_empty_announcement: '暂无公告',
  label_comma: '，',
  label_new_and_relate_project: '新建并关联',
  label_select_project_template: '请选择一个项目模板：',
  label_agile_product_develop: '敏捷产品研发',
  label_classic_project: '经典项目管理',
  label_defect_tracking: '缺陷跟踪',
  tip_agile_product_develop: '<div>- 使用主流敏捷方法学(Scrum/看板方法)管理研发过程</div><div>- 通过累积流图等度量工具辅助持续改进</div>',
  tip_classic_project: '<div>- 在一定的时间范围内，完成一个或多个明确的目标</div><div>- 跟踪项目的进度、风险、资源、里程碑计划等等</div>',
  tip_defect_tracking: '<div>规范的缺陷管理流程，及时有效的跟踪，保障质量</div>',
  tip_select_related_project: '请选择关联项目',
  label_relate_existing: '关联已有',
  label_display_columns: '显示列',
  label_milestone_gantt: '甘特图',
  label_plan_gantt: '规划甘特图',
  label_plan_task: '规划任务',
  text_plan_task_hint: '勾选任务，添加到甘特图',
  label_title: '标题',
  label_plan_start: '计划开始',
  label_plan_end: '计划完成',
  tip_gantt_owners: '项目PM，里程碑负责人或任务指派人',
  text_Display_archived_project: '显示已结项项目',
  label_project_template: '项目(集)模板',
  label_open_all: '展开所有',
  label_close_all: '收起所有',
  label_open: '展开',
  label_close: '收起',
  text_create_card_holder: '输入标题 @指派人，回车新建',
  sub_issue_search_placeholder: '输入标题或ID查找，回车关联',
  confirm_cancel_relation: '确认取消关联吗？',
  cancel_relation: '取消关联',
  label_current_project_set: '当前项目集',
  label_current_project: '当前项目',
  label_copy_from_other_project: '从其他项目复制',
  label_select_milestone_copy: '请选择要复制的里程碑',
  label_copy_milestone: '复制里程碑',
  label_more_info: '更多信息',
  label_project_message: '项目背景',
  text_ecs_region: '所属区域',
  text_ecs_instanceId: '实例id',
  text_ecs_instanceName: '实例名称',
  text_setting: '设置',
  text_default_open: '默认开启',

  label_step_1_project_info: '1. 填写项目信息',
  label_step_2_project_template: '2. 选择项目模板',
  label_req_workflow: '需求工作流',
  label_task_workflow: '任务工作流',
  label_bug_workflow: '缺陷工作流',

  label_system_template: '标准模板',
  label_division_template: '团队模板',
  // 英文模式下为Department 防止过长
  label_owner_division: '负责团队',
  label_belonged_project: '所属项目',
  label_colon: '：',
  label_product_is_required: 'BU/产品不能为空',
  tip_create_project: '请填写项目名称，建议不超过20个字',
  label_more_option: '更多操作',
  label_project_setting: '项目设置',
  label_turn_on_share: '开启跨企业共享',
  tip_delete_project: '删除项目，将同时删除归属于该项目的所有内容',
  tip_archive_project: '项目完成后，可将项目标记为结项。结项后不可重新开启，请谨慎操作。',
  tip_archive_tip_info: '<div>' +
  '<div>项目完成后，可将项目标记为结项。<span style="color: #fb8c00; font-weight: 600">结项后不可重新开启，请谨慎操作。</span></div>' +
  '<div>结项后会引起如下变化：</div>' +
  '<div>-<span style="color: #fb8c00">项目</span>：已结项的项目默认不显示在项目列表、项目搜索结果中；结项后不可修改模板；进度自动置为100%</div>' +
  '<div>-<span style="color: #fb8c00">图表</span>：已结项项目的工作项数据在图表统计时仍然会统计在内</div>' +
  '<div>-<span style="color: #fb8c00">迭代</span>：结项后不可新增迭代</div>' +
  '<div>-<span style="color: #fb8c00">工作项</span>：结项后不可新增工作项</div>' +
  '</div>',
  label_is_admin: '有管理权限',
  label_input_username: '请输入人名搜索',
  label_create_child_project: '创建子项目',
  label_relate_child_project: '关联子项目',
  label_create_child_project_set: '创建子项目集',
  label_relate_child_project_set: '关联子项目集',
  text_relate_child_project: '将以下项目关联成子项目',
  label_app_template: '应用模板',
  label_build_config: '构建配置',
  label_app_create_review: '应用信息预览',
  label_sure_to_create_app: '确定创建应用',
  label_go_to_application: '查看应用',
  layout_setting: '布局设置',
  label_repo_source: '代码源',
  label_repo: '仓库',
  label_gitee: '码云',
  label_template_name: '模板名称',
  label_select_app_template: '选择应用模板',
  label_language: '编程语言',
  label_other_language: '其他语言',
  label_deploy_options: '部署选项',
  label_aol: 'RDC脚本部署',
  label_aliyuncontainer: '阿里云容器服务Swarm集群',
  label_kubernetes: 'Kubernetes部署',
  label_edas: 'EDAS部署',
  label_sofa: 'SOFA部署',
  text_edit_roles: '编辑角色标签',
  text_del_role: '删除角色',
  text_del_role_confirm: '确定删除当前角色吗？',
  text_roles_name: '角色名称',
  text_switch_open: '开',
  text_switch_closed: '关',
  text_function_closed: '功能未开启',
  label_non_product: '非产品类',
  text_user_name: '用户名称',
  text_project_option: '项目操作',
  text_project_explanation: '需要在一定时间内完成的项目，通常经历立项、审批、结项流程',
  text_nameSpace_explanation: '长期存在的协作空间，无结项流程',
  tips_child_must_project_when_parent_is_project: '父项目模板为"项目"，子项目模板不可选择"业务空间"',
  tips_parent_must_business_when_child_is_business: '当前项目的模板是\'业务空间\'时，父项目模板不能是\'项目\'类型',
  tips_change_to_project_fail_error: '子项目有业务空间，当前项目的模板不能设为\'项目\'类型。请将以下子项目模板设为\'项目\'类型:',
  text_child_has_business: '子项目有业务空间',
  text_set_project_expected_date: '设置项目计划起止日期',
  label_closed_project: '已结项',
  text_lifecycle_abandoned: '该字段将被废弃,若项目完结或废弃，请到设置>更多>结项/删除',
  text_edit_progress: '编辑进度',
  text_resignation_batch_transfer: '批量转交',
  text_resignation_transfer_tip: ' 参与的项目',
  text_resignation_transfer_tip_title: '查看转交规则',
  text_resignation_transfer_tip_desc_0: '将我参与的项目转交给他人后，将执行以下操作',
  text_resignation_transfer_tip_desc_1: '1.将我在该项目中的成员角色替换成他人',
  text_resignation_transfer_tip_desc_2: '2.将该项目中指派给我的，未完成的工作项，改为指派给他人',
  text_resignation_transfer_tip_desc_3: '3.将该项目中抄送给我的，未完成的工作项，改为抄送给他人',
  text_resignation_transfer: '转交',
  text_resignation_project_name: '项目名称',
  text_resignation_role: '角色',
  text_resignation_undone_number: '未完成工作项数',
  text_resignation_department: '部门',
  text_resignation_operation: '操作',
  text_resignation_transfer_project: '转交项目',
  text_resignation_transfer_to: '转交给',
  text_resignation_choose_user: '请选择用户',
  text_resignation_transfer_success: '转交成功',
  text_resignation_transfer_failed: '转交失败',
  text_resignation_projects_selected_empty: '请选择要转交的项目',
  label_submit_approval: '提交审批',
  label_submit: '提交',
  text_plan_start_time_can_not_be_null: '项目计划开始时间不能为空',
  text_plan_end_time_can_not_be_null: '项目计划结束时间不能为空',
  text_cancel_approval_hint: '取消审批会终止项目创建流程',
  text_approval_list_hint: '提交后请到顶部导航“待办”>"我提交的"查看进展',
  text_error_get_bu: '获取Bu信息失败',
  text_business_recent90PV_zero_option: '项目已有90天无人访问，如项目已废弃，请删除',
  text_project_recent90PV_zero_option: '项目已有90天无人访问，如项目已完成，请结项；如项目已废弃，请删除',
  text_project_recent90PV_not_zero_option_1: '计划结束时间为$1。如项目已完成，请结项；如需延期,请',
  text_project_recent90PV_not_zero_option_2: '调整预计结束时间',
  text_project_recent90PV_not_zero_option_3: '切换为业务空间类模板',
  text_project_recent90PV_not_zero_option_4: ';如需长期使用，请',
  text_create_group_success: '创建分组成功',
  text_delete_group_success: '删除分组成功',
  text_update_group_success: '修改分组成功',
  text_remove_staff_code_access_of_this_region: '该用户在当前企业下有代码仓库或组的权限，回收用户代码权限',
  text_remove_code_access_failed: '用户已删除成功，但下列仓库或项目组的权限未删除(因当前操作人没有权限),请联系有权限的用户手工处理',
  text_system_remind: '系统提示',
  text_remove_member_remind: '删除用户后，用户将不能进入企业，用户的应用和流水线会转交给管理员',
  text_project_group_in_code: '项目组',
  label_project_template_setting: '项目模板',
  label_project_template_root_setting: '全局配置',
  label_project_services_setting: '项目服务',
  label_system_default: '系统',
  label_inherit: '上级',
  text_cf_detail: '属性详情',
  text_cf_name: '属性名称',
  label_field_format: '格式',
  label_cf_description: '提示文案',
  label_cf_required: '必填',
  label_cf_possible_value: '待选值',
  label_deleted_project: '已删除',
  text_project_group: '项目分组',
  text_product_line_edit_hint: '更多信息请到产品线页面编辑',
};

export default zh;



/** WEBPACK FOOTER **
 ** ./src/utils/locale/zh_CN.js
 **/